import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import { useLocation, useParams } from 'react-router-dom';
import { invoiceDetails } from '../../redux/Invoice/action';
import NewInvoiceV4 from './GenrateInvoice/NewInvoiceV4';

const InvoiceEdit = () => {
    const location = useLocation();
    const { id, appointmentId, customerId, type } = useParams();
    const dispatch = useDispatch();
    const [showLoader, setShowLoader] = useState(false);
    const [invoiceData, setInvoiceData] = useState(null);

    const formKey = [location.pathname, id ?? '', appointmentId ?? '', customerId ?? '', type ?? ''].join('|');

    const fetchInvoceDetailData = useCallback(async () => {
        if (!id) {
            return;
        }
        setShowLoader(true);
        const data = await dispatch(invoiceDetails(`${id}`));
        if (data) {
            setInvoiceData(data);
        }
        setShowLoader(false);
    }, [dispatch, id]);

    useEffect(() => {
        if (!id) {
            setInvoiceData(null);
            setShowLoader(false);
            return;
        }
        fetchInvoceDetailData();
    }, [id, fetchInvoceDetailData]);

    return (
        <NewInvoiceV4
            key={formKey}
            showLoader={showLoader}
            setShowLoader={setShowLoader}
            invoiceData={invoiceData}
            fetchInvoceDetailData={fetchInvoceDetailData}
        />
    );
};

export default InvoiceEdit;
